<script setup lang="ts">
import { useRoute } from 'vue-router';

import { logo, chouArtcutiersLogo } from '@/assets/images';

import { Committee } from '@/models';

import { routes } from '@/router';

import { useUserStore } from '@/stores';

const currentRoute = useRoute();
const { committee } = useUserStore();

const isInscriptionRoute = currentRoute.fullPath.startsWith('/inscription');
</script>

<template>
  <RouterLink :to="{ name: routes.home.name }" class="flex items-center">
    <img :src="committee === Committee.france && isInscriptionRoute ? chouArtcutiersLogo : logo" :alt="$t('logoAlt')" class="w-[6rem] md:w-[10rem]" />
  </RouterLink>
</template>
